import style from './workout-display.module.scss'
import { WorkoutVideo } from './workout-video'
import { Workout } from '../../dao/core-dao'
import { CommentsSection } from '../community/comments-section'
import { CompletedByHustlersFeed } from '../community/completed-by-hustlers-feed'
import { WorkoutDescription } from '../workout-description/workout-description'
import { WorkoutDetailAction } from '../workout-detail-action/workout-detail-action'
import { WorkoutDetailInfo } from '../workout-detail-info/workout-detail-info'
import { WorkoutTrainerInfo } from '../workout-trainer-info/workout-trainer-info'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

interface WorkoutDisplayProps {
  workout: Workout
  programmeId?: string
  programmeWorkoutId?: string
}

export const WorkoutDisplay = ({ workout, programmeId, programmeWorkoutId }: WorkoutDisplayProps): React.ReactElement => {
  return (
    <>
      <Col className="mt-5 mb-2 px-0">
        <WorkoutVideo workout={workout} programmeId={programmeId} programmeWorkoutId={programmeWorkoutId} />
      </Col>
      <Row className={style.trainerContainer}>
        <Col xs={7} sm={8} md={9} className="mt-3">
          <WorkoutTrainerInfo trainerId={workout.trainers?.[0]?.id ?? ''} />
        </Col>
        <Col xs={5} sm={4} md={3} className="mt-3">
          <WorkoutDetailAction workout={workout} />
        </Col>
      </Row>
      <WorkoutDetailInfo workout={workout} />
      <WorkoutDescription workout={workout} />
      <Row>
        <Col lg={8}>
          <CommentsSection entityId={workout.id} entityType="workout" />
        </Col>
        <Col lg={4}>
          <CompletedByHustlersFeed workoutId={workout.id} />
        </Col>
      </Row>
    </>
  )
}
